import { render, staticRenderFns } from "./ClaimApprovalInfo.vue?vue&type=template&id=0cdb9387"
import script from "./ClaimApprovalInfo.vue?vue&type=script&lang=js"
export * from "./ClaimApprovalInfo.vue?vue&type=script&lang=js"
import style0 from "./ClaimApprovalInfo.vue?vue&type=style&index=0&id=0cdb9387&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports